import components from './components';
import base from './base';
import { createApp } from 'vue';
const axios = require('axios');
import Modal from "./components/vueComponents/Modal.vue";
import InputCheckbox from "./components/vueComponents/InputCheckbox.vue";
import RetailersMap from "./components/vueComponents/RetailersMap.vue";

const container = document.getElementById('js_departments');

if (container) {
    run();
}

function run()
{
    const siteId = JSON.parse(container.getAttribute('data-siteid'));

    createApp({
        delimiters: ['@{', '}'],
        data() {
            return {
                a : 'departments',
                retailerSearch : '',
                includedBrands: [],
                retailerList : [],
                filteredRetailers: [],
                currentRetailer : null,
                retailerId : null,
                siteId : siteId,
                responseStatus : null,
                responseMessage : null,
                departmentContent: null,
                components: components,
                baseComponents: base,
                loading: true,
                brand: null,
                initialRetailerId: null,
            }
        },

        components : {
            InputCheckbox,
            Modal,
            RetailersMap
        },

        filters:
        {
            km(value)
            {
                return parseInt(value);
            }
        },

        created()
        {
            this.host           = document.querySelector('[name="site_root"]').content;
            this.redirect       = window.location.href;
            this.getRetailers();
            this.setBaseComponents();
            this.getQueryParams();
        },

        computed:{
            isInternalDepartment(){
                return !!(this.currentRetailer && this.currentRetailer.site_id);
            },
            retailerUrl(){
                // TODO, maybe currentRetailer.site_url or currentRetailer.url
                return this.currentRetailer.www;
            },
            showUrlToRetailer(){
                return this.initialRetailerId != this.retailerId;
            },
        },

        methods:
        {
            setBaseComponents(){
                for (let i in this.baseComponents) {
                    let component = this.baseComponents[i];
                        if (typeof component === 'object' && component.hasOwnProperty('default'))
                            component.default.hasOwnProperty('init') ? component.default.init() : null;
                    }
            },

            setComponents(){
                for (let i in this.components) {
                    let component = this.components[i];
                        if (typeof component === 'object' && component.hasOwnProperty('default')) {
                            console.log(component.default.name)
                            // TODO, hotfix
                            if(i !== 'productContact') {
                                component.default.hasOwnProperty('init') ? component.default.init() : null;
                            }
                    }
                }
             },

            resetRetailer(){
                this.currentRetailer = null;
            },

            showAll() {
                this.filteredRetailers = this.retailerList;
            },

            resetRetailerSearch() {
                this.retailerSearch = '';
                this.filterRetailers();
            },

            getQueryParams() {
                const currentURL = new URL(window.location.href);
                const searchParams = currentURL.searchParams;

                let brands = searchParams.get('brands');
                brands = brands ? brands.split(',') : [];

                if(brands.length){
                    this.includedBrands = brands;
                }

            },

            updateParamURL(param, value) {
                const currentURL = new URL(window.location.href);
                const searchParams = currentURL.searchParams;

                if(!value){
                    searchParams.delete(param);
                } else {
                    searchParams.set(param, value);
                }


                history.pushState(null, document.title, decodeURIComponent(currentURL.toString()));
            },

            updateQueryParams() {
                let brands = '';

                if(this.includedBrands.length){

                    this.includedBrands.forEach((brand, i) => {
                        brands += brand;
                        brands += i === this.includedBrands.length-1 ? '' : ',';
                    });

                }
                this.updateParamURL('brands', brands);

            },

            getUsersGeoPosition() {
                /* this.lat = 62.8413603;
                this.lng = 7.2272497; */

                if (!navigator.geolocation) {
                  console.warn('Geolocation is not supported');
                } else {
                    //console.log('locating ...');
                    const options = {enableHighAccuracy: true, maximumAge: 10000};
                    navigator.geolocation.getCurrentPosition(
                        this.getUsersGeoPosition__success,
                        this.getUsersGeoPosition__error, options
                    );
                }
            },

            getUsersGeoPosition__success(position) {
                // console.log('getUsersGeoPosition__success');
                this.lat = parseFloat(position.coords.latitude.toFixed(2));
                this.lng = parseFloat(position.coords.longitude.toFixed(2));
                // console.log(this.lat);
                // console.log(this.lng);
                setTimeout(this.filterRetailers, 500);
            },

            getUsersGeoPosition__error(error) {
               console.warn(error);
               this.filterRetailers();
            },

            calcDistance (lat1, lon1, lat2, lon2, unit) {
                if ((lat1 == lat2) && (lon1 == lon2)) {
                    return 0;
                }
                else {
                    var radlat1 = Math.PI * lat1/180;
                    var radlat2 = Math.PI * lat2/180;
                    var theta = lon1-lon2;
                    var radtheta = Math.PI * theta/180;
                    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                    if (dist > 1) {
                        dist = 1;
                    }
                    dist = Math.acos(dist);
                    dist = dist * 180/Math.PI;
                    dist = dist * 60 * 1.1515;
                    if (unit=="K") { dist = dist * 1.609344 }
                    if (unit=="N") { dist = dist * 0.8684 }
                    return dist;
                }
            },

            findRetailer() {
                this.filterRetailers();
            },

            filterBySearchString(item) {
                let isValid = true;

                if (this.retailerSearch) {
                    isValid = false;
                    // find retailer name
                    if (item.name.toLowerCase().search(this.retailerSearch) !== -1) {
                        isValid = true;
                    }

                    // find retailer city
                    if (item.city.toLowerCase().search(this.retailerSearch) !== -1) {
                        isValid = true;
                    }

                    // find retailer zipcode
                    if (item.zipcode.toLowerCase().search(this.retailerSearch) !== -1) {
                        isValid = true;
                    }
                }

                return isValid;
            },

            filterByBrand(item){
                let isValid = false;

                if (item.included.brands.some(el => el.name && this.includedBrands.includes(el.name))) {
                        isValid = true;
                    }

                return isValid;
            },

            filterRetailers() {
                let filteredItems = this.retailerList.filter(this.filterBySearchString);

                if(this.includedBrands.length){
                    filteredItems = filteredItems.filter(this.filterByBrand);
                }


                if (this.lat && this.lng) {
                    filteredItems.map((retailer) => {
                        if (typeof retailer.position === 'object' && retailer.position !== null) {
                            retailer.distance = this.calcDistance(this.lat, this.lng, retailer.position.lat, retailer.position.lng, "K");
                        } else {
                            retailer.distance = 0;
                        }

                        return retailer;
                    });

                    filteredItems.sort((a, b) => (a.distance > b.distance) ? 1 : -1)
                }

                if (filteredItems.length === 0){
                    console.log('No retailers');
                    /* filteredItems = this.retailerList; */
                };

                this.filteredRetailers = filteredItems;
                this.updateQueryParams();

            },


            getRetailers() {
                axios.get('/actions/ck/ck/get-all-retailers')
                    .then(this.getRetailers__callback)
                    .then(this.getDepartmentContactContent)
                    .catch(this.axios__error);
            },

            parseForDepartments(string){
                string = string.replace(/(content-width--medium)|(content-width--small)/g, "");
                return string
            },

            getDepartmentContactContent() {
                this.loading = true;
                this.departmentContent = null;

                if(!this.currentRetailer){
                    return;
                }

                let url = this.host + 'actions/ck/ck/get-department-contact-content?retailerId='+this.currentRetailer.id;

                if(this.currentRetailer.site_id){
                    url += '&siteId='+this.currentRetailer.site_id;
                }

                // console.log(url);
                axios.get(url)
                .then(response => {
                    this.departmentContent = this.parseForDepartments(response.data);
                })
                .then(this.setComponents)
                .then(() => this.loading = false)
                .catch(this.axios__error);
            },

            getRetailers__callback(response) {
                if (typeof response.data === 'object') {
                    this.retailerList = response.data;
                    this.filteredRetailers = response.data;

                    if (Number.isInteger(this.siteId)) {
                        for(let i=0; i<this.retailerList.length; i++) {
                          /*   console.log(this.retailerList[i].site_id); */
                            if (this.retailerList[i].site_id == this.siteId) {
                                this.currentRetailer = this.retailerList[i];
                                console.log(this.retailerList[i]);
                                this.retailerId = this.retailerList[i].id;
                                this.initialRetailerId = this.retailerList[i].id;
                                break;
                            }
                        }
                    }
                }
                console.log(this.siteId);
                this.filterRetailers();
            },

            changeRetailer(id) {
                this.retailerId = id;

                const newRetailer = this.retailerList.filter(this.findRetailerById);

                if (typeof newRetailer === 'object' && newRetailer.length===1) {
                    this.currentRetailer = newRetailer[0];

                    this.getDepartmentContactContent();
                    return;
                }

                this.currentRetailer = null;
            },

            findRetailerById(item) {
                return (item.id == this.retailerId) ? true : false;
            },

            axios__error(error) {
                console.error('axios__error ');
                console.log(error);
                this.responseStatus = 'error';
                this.responseMessage = error;
            }
        }
    }).mount('#js_departments'); // end of vue;
}
